export default __webpack_public_path__ + "static/media/wicon.8de93d38.png";